import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout | error

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    let stop = false;
    const poll = async () => {
      if (stop) return;
      if (attempts >= 8) { setState("timeout"); return; }
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired") { setState("error"); return; }
      } catch { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div className="max-w-lg mx-auto mt-10 brut-card p-8 text-center space-y-4" data-testid="billing-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="w-12 h-12 mx-auto animate-spin text-[#1F5F3F]" />
          <h1 className="font-heading text-2xl font-black">Confirming your payment…</h1>
          <p className="text-sm text-zinc-600 font-mono">Please don't close this tab.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-[#2E8B57]" />
          <h1 className="font-heading text-2xl font-black">Subscription activated!</h1>
          <p className="text-sm text-zinc-600">Your plan is live. Manage it anytime from Organizations.</p>
          <Link to="/organizations" className="brut-btn px-4 py-2 text-sm inline-block" data-testid="billing-back-to-orgs">GO TO ORGANIZATIONS</Link>
        </>
      )}
      {(state === "timeout" || state === "error") && (
        <>
          <XCircle className="w-14 h-14 mx-auto text-red-600" />
          <h1 className="font-heading text-2xl font-black">{state === "timeout" ? "Still processing" : "Payment not confirmed"}</h1>
          <p className="text-sm text-zinc-600">
            {state === "timeout"
              ? "The payment is taking longer than expected. Check your email for confirmation — the plan activates automatically once payment clears."
              : "We couldn't verify this payment session. If you were charged, contact support."}
          </p>
          <Link to="/organizations" className="brut-btn-secondary px-4 py-2 text-sm inline-block">BACK TO ORGANIZATIONS</Link>
        </>
      )}
    </div>
  );
}
